import { filter, propEq, propOr } from 'ramda';
import { useMemo } from 'react';
import { getReimbursementGraphContent } from './helpers/getReimbursementGraphContent.js';

const useNiveauxGarantiesTarifsPrevTnsInvaliditeForm = ({
  form,
  guarantees,
  getMiddleText,
  annualIncome
}) => {
  const garInval = form.watch('guarantees.OPTION_INVAL.selected');
  const garInvalOptionDep = form.watch('guarantees.OPTION_INVAL_DEP.selected');
  const invalCap = form.watch('guarantees.INVAL_CAP.value');
  const invalRO = form.watch('guarantees.OPTION_INVAL.RO');

  const {
    OPTION_INVAL,
    INVAL_MAD,
    OPTION_INVAL_DEP,
    INVAL_DEP_CAP
  } = guarantees;

  // Calcul dynamique de la part assureur pour INVAL_CAP (3 catégories d'invalidité)
  // RG: Revenu*niveau de garantie choisi - Montant RO (Plafonné à min 0 euros)
  const invalHealthInsurances = useMemo(() => {
    if (!garInval || !invalCap) return [];

    // Les valeurs sont toujours séparées par '_' depuis le backend (ex: "0_50_100")
    const percentages = invalCap.split('_').map(v => parseFloat(v) || 0);
    const ROs = invalRO || [];

    return percentages.map((percentage, index) => {
      const insurerAmountBeforeRO = annualIncome * (percentage / 100);
      const roAmount = parseFloat(ROs[index] || 0);

      // Soustraire le RO et plafonner à min 0
      const insurerAmount = Math.max(0, insurerAmountBeforeRO - roAmount);

      return insurerAmount.toString();
    });
  }, [garInval, invalCap, invalRO, annualIncome]);

  const invaliditeCotisation = [
    {
      displayed: garInval,
      label: getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INVAL_LABEL'),
      monthlyAmount: propOr(0.0, 'monthlyPrice', OPTION_INVAL),
      yearlyAmount: propOr(0.0, 'annualPrice', OPTION_INVAL)
    },
    {
      displayed: garInvalOptionDep,
      label: getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INVAL_OPTION_DEPENDANCE_LABEL'),
      monthlyAmount: propOr(0.0, 'monthlyPrice', INVAL_DEP_CAP),
      yearlyAmount: propOr(0.0, 'annualPrice', INVAL_DEP_CAP)
    }
  ];

  const invalReimbursementGraphContent = getReimbursementGraphContent(
    invalHealthInsurances,
    propOr([], 'labelsRO', OPTION_INVAL),
    invalRO || []
  );

  return {
    garInval,
    garInvalOptionDep,
    OPTION_INVAL,
    INVAL_MAD,
    OPTION_INVAL_DEP,
    invaliditeCotisation: filter(propEq('displayed', true), invaliditeCotisation),
    invalHealthInsurances,
    invalReimbursementGraphContent
  };
};

export default useNiveauxGarantiesTarifsPrevTnsInvaliditeForm;
